module.exports = __webpack_public_path__ + "img/ajax.cc387905.gif";